/*=========================================================================================
  File Name: getters.js
  Description: Vuex Store - getters
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

// added so later we can keep breakpoint in sync automatically using this config file
// import tailwindConfig from "../../tailwind.config.js"

const getters = {
    // COMPONENT
    // vx-autosuggest
    // starredPages: state => state.navbarSearchAndPinList.data.filter((page) => page.highlightAction),
    windowBreakPoint: state => {
        // This should be same as tailwind. So, it stays in sync with tailwind utility classes
        if (state.windowWidth >= 1200) return 'xl';
        else if (state.windowWidth >= 992) return 'lg';
        else if (state.windowWidth >= 768) return 'md';
        else if (state.windowWidth >= 576) return 'sm';
        else return 'xs';
    },

    scrollbarTag: state => {
        return state.is_touch_device ? 'div' : 'VuePerfectScrollbar';
    },

    getTOKEN: function(state) {
        return state.token;
    },

    getUSERNAME: function(state) {
        return state.username;
    },

    getUID: function(state) {
        return state.uid;
    },

    getCDLEVEL: function(state) {
        return state.cd_level;
    },

    getTABSUM: function(state) {
        return state.tab_sum;
    },

    getTABSUM_01: function(state) {
        return state.tab_sum_01;
    },

    getTABSUM_03: function(state) {
        return state.tab_sum_03;
    },
    getMemberEmail: function(state) {
        return state.memberEmail;
    },
};

export default getters;
